import React, { useState } from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import "./question.css";

const QuestionsInvisalign = () => {
  const [activeKeys, setActiveKeys] = useState([]);

  const handleToggle = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4 fs-40 ">FAQs</h2>
      <Row className="p-md-4">
        <Col md={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="0"
              onClick={() => handleToggle("0")}
            >
              <Accordion.Header as="h3" className="red-header">
                How will Invisalign® treatment straighten my teeth?
              </Accordion.Header>
              <Accordion.Body>
                A unique, digital treatment plan that maps out the exact
                movements of your teeth is created. Your Invisalign® clear
                aligners are then designed to apply the right amount of force to
                the right place at the right time based on your plan. We will be
                with you every step of the way to monitor your progress and
                ensure your aligners fit correctly.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="1"
              onClick={() => handleToggle("1")}
            >
              <Accordion.Header as="h3" className="red-header">
                How long will treatment take?
              </Accordion.Header>
              <Accordion.Body>
                The length of treatment depends on multiple factors, like how
                complex your case is and how often you wear your aligners. We
                will determine how long your treatment could take based on your
                specific needs. On average, Invisalign® treatment time is 6 to
                18 months, though you can start seeing results in a matter of
                weeks.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="4"
              onClick={() => handleToggle("4")}
            >
              <Accordion.Header as="h3" className="red-header">
                Are there any restrictions on what I can eat while in treatment?
              </Accordion.Header>
              <Accordion.Body>
                None! Invisalign® clear aligners are removable, so there are no
                food restrictions at all. With traditional wires and brackets,
                there’s a long list of foods you unfortunately can’t enjoy, as
                they can damage or get stuck in your braces.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="6"
              onClick={() => handleToggle("6")}
            >
              <Accordion.Header as="h3" className="red-header">
                Is Invisalign® better than braces?
              </Accordion.Header>
              <Accordion.Body>
                Both are options. In some instances, braces are better suited
                than Invisalign®, in others Invisalign® is a better option. It
                also depends on your lifestyle and what fits for you. A
                consultation with our dentist will help you choose the right
                option for you.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="8"
              onClick={() => handleToggle("8")}
            >
              <Accordion.Header as="h3" className="red-header">
                Can you drink water with Invisalign®?
              </Accordion.Header>
              <Accordion.Body>
                Yes. You can drink any drink with Invisalign®. If it’s a hot
                drink or a drink that could stain the aligners, then its advised
                to remove them to have the drink and then put them back in. If
                its water, then you wouldn’t need to remove your aligners.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col md={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="3"
              onClick={() => handleToggle("3")}
            >
              <Accordion.Header as="h3" className="red-header">
                How much does Invisalign® cost and do you offer finance?
              </Accordion.Header>
              <Accordion.Body>
                Like other types of orthodontic treatment, the price of the
                Invisalign® treatment depends on the complexity of your dental
                correction and your course of treatment.
                <br /> The dental practice do have finance options and you can
                discuss these with one of the treatment co-ordinators as part of
                your consultation.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="2"
              onClick={() => handleToggle("2")}
            >
              <Accordion.Header as="h3" className="red-header">
                Is Invisalign® treatment painful?
              </Accordion.Header>
              <Accordion.Body>
                Invisalign® treatment moves your teeth by applying gentle,
                constant force, but some people do feel temporary discomfort for
                the first few days of wearing a new set of aligners.
                <br /> Typically, people describe it as feeling “pressure” and
                it’s normal — it’s a sign your Invisalign® clear aligners are
                working and transforming your smile.
                <br /> If you do have any concerns you will be able to get in
                touch with one of the team who will be able to discuss your
                concerns.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="5"
              onClick={() => handleToggle("5")}
            >
              <Accordion.Header as="h3" className="red-header">
                What are the advantages of Invisalign®?
              </Accordion.Header>
              <Accordion.Body>
                Invisalign® provides a discreet option to straighten your teeth.
                It also allows you to straighten your teeth with minimal
                interference on your day-to-day life – so you can eat, drink and
                enjoy the things as normal.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="7"
              onClick={() => handleToggle("7")}
            >
              <Accordion.Header as="h3" className="red-header">
                Does Invisalign® change your face shape?
              </Accordion.Header>
              <Accordion.Body>
                Invisalign® uses thin plastic trays so this shouldn’t have any
                impact on your visual appearance. The discretion that
                Invisalign® provides is one of the key benefits.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default QuestionsInvisalign;
